export default __webpack_public_path__ + "static/careers-benefits-block2-icon02.url-81284418442f297f5b51e22b24601558.svg";